<template>
  <div v-if="expressionBesoin">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="icons.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Date</span>
                  </td>
                  <td>{{ expressionBesoin.date }}</td>
                </tr>

                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Priorité</span>
                  </td>
                  <td>
                    <span :style="{ color: expressionBesoin.priorite.couleur }">
                      {{ expressionBesoin.priorite.nom }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_USER" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      expressionBesoin.created_by.prenom
                        ? expressionBesoin.created_by.prenom +
                          ' ' +
                          expressionBesoin.created_by.nom
                        : expressionBesoin.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="icons.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Date de réception</span>
                  </td>
                  <td>{{ expressionBesoin.date_reception }}</td>
                </tr>

                <tr>
                  <td>
                    <i
                      :class="icons.ICON_COMMENT"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Commentaire</span>
                  </td>
                  <td class="text-primary">
                    {{ expressionBesoin.commentaire }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body mb-n2">
              <div class="row d-lg-flex justify-content-lg-center">
                <div class="col-md-4 col-lg-2">
                  <div class="form-group">
                    <label for="date"
                      >Date <span class="text-danger">*</span></label
                    >
                    <date-picker
                      v-model="expressionBesoin.date"
                      name="date"
                      placeholder="Date"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                      disabled
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-4 col-lg-2">
                  <div class="form-group">
                    <label for="date_reception"
                      >Date de réception
                      <span class="text-danger">*</span></label
                    >
                    <date-picker
                      v-model="expressionBesoin.date_reception"
                      name="date_reception"
                      placeholder="Date de réception"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                      disabled
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-4 col-lg-2">
                  <div class="form-group">
                    <label for="priorite"
                      >Priorité <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      disabled
                      label="nom"
                      :options="priorites"
                      :reduce="(priorite) => priorite.uuid"
                      v-model="expressionBesoin.priorite"
                      placeholder="Priorité"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="priorite"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                  </div>
                </div>
                <div class="col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="commentaire"
                      >Commentaire (max : 150 caractères )
                    </label>
                    <textarea
                      v-model="expressionBesoin.commentaire"
                      class="form-control"
                      rows="5"
                      maxlength="150"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div-->

      <div class="row mt-n2">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-4">Référence</th>
                <th class="col-6">Désignation</th>
                <th class="col-2 text-center">Quantité</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in expressionBesoin.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-4" style="vertical-align: middle">
                  {{ item.reference }}
                </td>
                <td class="col-6" style="vertical-align: middle">
                  {{ item.designation }}
                </td>
                <td class="col-2 text-center" style="vertical-align: middle">
                  {{ item.quantite + ' ' + item.unite }}
                </td>
              </tr>
              <tr
                v-if="expressionBesoin.item_lists.length === 0"
                class="d-flex"
              >
                <td colspan="3" class="text-center col-12">Aucune donnée</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/expression-besoin';
import { show as icons } from '@/icons/achat/expression-besoin';
export default {
  data() {
    return {
      expressionBesoin: null,
      id: null,
      icons,
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.EXPRESSION_BESOIN + '/' + this.id)
        .then((resp) => {
          this.expressionBesoin = resp.data.expression_besoin;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.table td {
  vertical-align: middle;
  font-size: 16px;
}
</style>
